/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

/**
 * `true` when running inside a Tauri WebView (desktop or iOS shell). Detected
 * by the `__TAURI_INTERNALS__` global Tauri injects into every webview before
 * any app code runs.
 */
export const IS_TAURI = '__TAURI_INTERNALS__' in globalThis

/**
 * `true` on Safari user agents. The regex excludes Chrome and the Chrome/Firefox
 * iOS variants (crios/fxios) which also carry "Safari" in their UA string.
 */
export const isSafari =
    typeof navigator !== 'undefined' &&
    /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent)

/**
 * `true` where video plays as HLS with FairPlay: Safari, and WKWebView shells (the Tauri macOS
 * and iOS apps), whose user agent has no "Safari" token but which expose `WebKitMediaKeys`.
 * Same feature test vinyl-amzn uses to pick HLS over DASH for audio.
 */
export const usesFairPlay =
    isSafari || (typeof globalThis !== 'undefined' && 'WebKitMediaKeys' in globalThis)

const MOBILE_USER_AGENTS = ['iPhone', 'iPad', 'iPod', 'Android', 'Kindle', 'Silk', 'Windows Phone']

/** GH's `isMobileUserAgent`: the user agent names a phone, tablet or e-reader. */
export function isMobileUserAgent(): boolean {
    const ua = globalThis.navigator.userAgent
    return MOBILE_USER_AGENTS.some((device) => ua.includes(device))
}
